import {Page} from "@/libwyze-shared/types";
import React, {ReactElement} from "react";
import {Typography} from "@mui/material";
import {StyledBoxColumn, StyledBoxRow, StyledSpan} from "@/shared/StyledComponents";
import {CheckinType} from "@/checkin-common/types";
import {CheckinScreenType, CheckinState} from "./CheckinPlayerPreviewFragment";
import {
  CalendarMonthOutlined,
  DirectionsWalkOutlined,
  LockOutlined,
  PersonAddAltOutlined,
} from "@mui/icons-material";
import {BORDER_RADIUS_MEDIUM, PD_LG, PD_MD, PD_XSM} from "@/shared/dimens";
import {colorAlabaster, colorLightPastelBlue} from "@/shared/colors";
import {ChooseCard} from "./components/ChooseCard";

export function ChooseVisitTypeScreen(props: {
  practicePage: Page,
  pushScreenType: (st: CheckinScreenType) => void,
  checkinState: CheckinState,
  setCheckinState: (checkin: CheckinState) => void,
}): ReactElement {
  return <>
    <StyledBoxColumn style={{alignItems: "flex-start", gap: 0}}>
      <Typography variant={"h2"} style={{fontWeight: 900}}>
        How can we help you today?
      </Typography>
      <Typography style={{fontSize: "100%", opacity: 0.5}}>
        Choose the option that fits your visit.
      </Typography>
    </StyledBoxColumn>
    <StyledBoxRow style={{width: "100%", gap: 16}}>
      <ChooseCard
        icon={<CalendarMonthOutlined/>}
        title="I have an appointment"
        description="Check in with your QR code, appointment code, or phone number."
        highlighted={true}
        onClick={() => {
          props.setCheckinState({...props.checkinState, type: CheckinType.CHECKIN});
          props.pushScreenType(CheckinScreenType.FIND_APPOINTMENT);
        }}
      />
      {/*<ChooseCard*/}
      {/*  icon={<PersonAddAltOutlined/>}*/}
      {/*  title="I'm a new patient"*/}
      {/*  description="Register and complete your intake forms. Takes only a few minutes."*/}
      {/*  onClick={() => {*/}
      {/*    props.setCheckinState({...props.checkinState, type: CheckinType.REGISTER});*/}
      {/*    props.pushScreenType(CheckinScreenType.REGISTER_FORM);*/}
      {/*  }}*/}
      {/*/>*/}
      <ChooseCard
        icon={<DirectionsWalkOutlined/>}
        title="Walk-in, no appointment"
        description="Let us know you're here. We'll fit you in when a slot opens up."
        onClick={() => {
          props.pushScreenType(CheckinScreenType.PATIENT_TYPE);
        }}
      />
    </StyledBoxRow>
    <StyledSpan/>
    <StyledBoxRow style={{
      backgroundColor: colorLightPastelBlue,
      borderRadius: BORDER_RADIUS_MEDIUM,
      padding: `${PD_MD}px ${PD_LG}px`,
      alignItems: "center",
    }}>
      <LockOutlined/>
      <StyledBoxColumn style={{gap: PD_XSM}}>
        <Typography variant={"h6"}>
          Your information is private.
        </Typography>
        <Typography style={{opacity: 0.5}}>
          This kiosk auto-clears when you're done.
        </Typography>
      </StyledBoxColumn>
    </StyledBoxRow>
  </>;
}
